﻿'use strict'
module.exports = {
  NODE_ENV: '"prod"',
  TITLE:'"-clsprod"',
  API_DOMAIN: '"https://clsapi.canon.com.cn"',                   //api域名
  API_PATH: '"/clsprod"',
  BASE_PATH: '""',
  GET_VERIFY_CODE: '"/sso/getVerifyCode"', // 图形验证码
  GET_SMS_CODE:'"/sso/getSMSCode"', //短信验证码
  POST_LOGIN: '"/sso/login"', //登录
  LOGOUT: '"/sso/logout"', //退出登录
  GET_CONTACT:'"/api/order/getContact"',  //getContact
  GET_PLAN:'"/api/order/plan"',  //商品列表页
  PLAN_DETAIL:'"/api/order/planDetail"', // 查看商品详情
  PAYMENT_PLAN:'"/api/order/getPaymentUrl"', //去支付
  GET_ORDER_LIST:'"/api/order/getOrderList"',  //订单列表
  CANCEL_ORDER:'"/api/order/cancelOrder"',  //取消订单
  REGET_PAYMENT:'"/api/order/regetPaymentUrl"',  //重新支付
  GET_RESERVATION_LIST:'"/api/order/getReservationList"',   //获取服务列表
  GET_ORDER_STATUS: '"/api/order/getOrderStatus"', //支付结果
  SET_COMMENT:'"/api/order/setComment"', //发表评价
  GET_COMMENT:'"/api/order/getComment"', // 获取评价
  USER_REFUND:'"/api/order/requestRefund"', // 申请退款
  USER_RESETUP:'"/api/order/requestReSetup"',//申请售后
  // 服务商
  ACCOUNT_LOGIN:'"/account/login"',//服务商登录
  ACCOUNT_LOGOUT:'"/account/logout"',//服务商退出登录
  ACCOUNT_GET_VERIFY_CODE:'"/account/getVerifyCode"',//服务商获取code
  GET_SERVER_RESERVATION_LIST:'"/api/vendor/getReservationList"', //获取服务
  RESERVE:'"/api/vendor/reservation"', //确定服务
  STARTSERVICE:'"/api/vendor/startService"', //开始服务
  CHANGERESERVE:'"/api/vendor/changeReservation"', //修改服务
  GET_VERIFICATION_LINK:'"/api/vendor/getVerificationLink"', //获取核销链接
  SET_VERIFICATION_LINK:'"/api/vendor/setVerificationLink"', //获取核销链接
  VERIFICATION:'"/api/vendor/verification"', //本地核销
  ACTIVE_VERIFICATION_LINK:'"/api/vendor/activeVerificationLink"',//链接核销
  VENDOR_GET_COMMENT:'"/api/vendor/getComment"',//获取当个评价
  GETSERVICE:'"/api/vendor/service"', //获取服务产品列表
  CLOSERESETUP:'"/api/vendor/closeReSetup"',//服务商完成再次精调
  CHANGERESERVATION:'"/api/vendor/changeReservation"',//关闭服务
  GETUPLOADQAFILEURL:'"/api/vendor/getUploadQAFileURL"',//获取上传路径
  CHECKQAFULESTATUS:'"/api/vendor/checkQAFileStatus"',//获取上传状态
  CHANGEPASSWORD:'"/api/vendor/changePassord"',//修改密码
  NOCODEVERIFICATION:'"/api/vendor/noCodeVerification"',//申请调试完毕
  // 服务人员
  GETENGINEERS:'"/api/vendor/getEngineers"',
  ADDENGINEERS:'"/api/vendor/addEngineer"',
  DELENGINEERS:'"/api/vendor/delEngineer"',
  // 报告
  FINDRESERVATION:'"/api/vendor/findReservation"',
  EXPORTRESERVATION:'"/api/vendor/exportReservation"', //导出
  GETEXPORTSTATUS:'"/api/vendor/getExportStatus"',
  // 路由 以及 302 跳转 生产环境

  WRITEOFF:'"https://cls.canon.com.cn/sure_write_off"', //核销链接页面
  API_LOCAL: '"https://cls.canon.com.cn/login_callback"', //登录重定向路由
  PAYMENT_PAGE:'"https://cls.canon.com.cn/result"',    //购买重定向路由

  //其它
  COUNT_DOWN:'"60"',  //倒计时
  LIST_NUMBER:'5', //每页显示几条
  PAGER_COUNT_MOBILE:'5', //移动端页码按钮数
  PAGER_COUNT_PC:'7', //PC端页码按钮数
  SERVICE_UPDATE:'"false"',  //更新服务 

  ICP_RECORE_NO:'"https://beian.miit.gov.cn/#/Integrated/index"',  //ICP备案号
  PUBLIC_RECORE_NO:'"http://www.beian.gov.cn/portal/registerSystemInfo"',  //公网安备案号
  USER_PRIVACY:'"https://www.canon.com.cn/about/secrecy/index.html"',//佳能官网隐私政策
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 19